
import {React, useEffect} from 'react';
import DynamicForm from '../../components/common/form';

const AdminForm = ({ initialData, onSubmit, onCancel }) => {
  const isEdit = Boolean(initialData && Object.keys(initialData).length);
  const EMPTY_VALUES = {
  name: '',
  email: '',
  password: '',
  role: 'admin', 
};

  const fields = [
    
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      placeholder: 'Enter full name',
      required: true,
       autoComplete: 'off',
    },
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'Enter email address',
      required: true,
      autoComplete: 'off',
    },
    {
      name: 'password',
      label: 'Password',
      type: 'password',
      placeholder: isEdit  ? 'Leave blank to keep unchanged' : 'Enter password',
      required: !isEdit ,
      autoComplete: 'new-password',
    },
    {
      name: 'role',
      label: 'Role',
      type: 'select',
      placeholder: isEdit  ? 'Leave blank to keep unchanged' : 'Enter Role',
      required: !isEdit ,
      // ? false : true,
      options :[
        { value: 'admin', label: 'Admin' },
        // { value: 'editor', label: 'Editor' },
        { value: 'eventmanager', label: 'Event Manager' },
        // { value: 'eventcreator', label: 'Event Creator' },
]
    },
  ];

  return (
    <DynamicForm
    key={isEdit ? initialData?._id : 'create-admin'} 
       initialValues={isEdit  ? initialData : EMPTY_VALUES}
      fields={fields}
   
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitText="Save Admin"
      cancelText="Cancel"
    />
  );
};

export default AdminForm;
